import { Loader2 } from 'lucide-react';

import { LinkListItem } from './LinkListItem';

import { Button } from '@/components/ui/button';
import { useListLinks } from '@/hooks/useLinks';

export function LinkListPage(): React.ReactElement {
  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useListLinks();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-4 text-center text-destructive">
        {error.message}
      </div>
    );
  }

  const items = data?.pages.flatMap((page) => page.items) ?? [];

  if (items.length === 0) {
    return (
      <div className="rounded-lg border bg-muted/50 p-8 text-center">
        <p className="text-muted-foreground">まだリンクがありません</p>
        <p className="mt-1 text-sm text-muted-foreground">
          「リンク作成」タブで新しいリンクを作成してください
        </p>
      </div>
    );
  }

  const handleLoadMore = (): void => {
    void fetchNextPage();
  };

  return (
    <div className="space-y-4">
      {items.map((item) => (
        <LinkListItem key={item.id} item={item} />
      ))}

      {hasNextPage && (
        <div className="flex justify-center pt-4">
          <Button
            variant="outline"
            onClick={handleLoadMore}
            disabled={isFetchingNextPage}
          >
            {isFetchingNextPage ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                読み込み中...
              </>
            ) : (
              'さらに読み込む'
            )}
          </Button>
        </div>
      )}
    </div>
  );
}
